import React from "react";

const CopyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.936"
      height="23.083"
      viewBox="0 0 19.936 23.083"
    >
      <path
        id="ic_content_copy_24px"
        d="M16.689,1H4.1A2.1,2.1,0,0,0,2,3.1V17.788H4.1V3.1H16.689Zm3.148,4.2H8.3A2.1,2.1,0,0,0,6.2,7.3V21.985a2.1,2.1,0,0,0,2.1,2.1H19.837a2.1,2.1,0,0,0,2.1-2.1V7.3A2.1,2.1,0,0,0,19.837,5.2Zm0,16.788H8.3V7.3H19.837Z"
        transform="translate(-2 -1)"
      />
    </svg>
  );
};

export default CopyIcon;
